import { render, staticRenderFns } from "./QuadroAlertaZfm.vue?vue&type=template&id=243eadce&scoped=true&"
import script from "./QuadroAlertaZfm.vue?vue&type=script&lang=js&"
export * from "./QuadroAlertaZfm.vue?vue&type=script&lang=js&"
import style0 from "./QuadroAlertaZfm.vue?vue&type=style&index=0&id=243eadce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243eadce",
  null
  
)

export default component.exports